import React from "react";
import { FiFeather, FiShield, FiCheckCircle, FiHeart } from "react-icons/fi";
import CtaBanner from "../components/CtaBanner";

const VALUES = [
  {
    icon: FiFeather,
    title: "Simplicity",
    copy: "We make complex accounting simple and easy to use for everyone.",
  },
  {
    icon: FiShield,
    title: "Security",
    copy: "Your data security and privacy are our top priorities, always.",
  },
  {
    icon: FiCheckCircle,
    title: "Reliability",
    copy: "Built with reliability to keep your business running smoothly.",
  },
  {
    icon: FiHeart,
    title: "Customer First",
    copy: "You can rely on us. We're here to help you succeed, every step of the way.",
  },
];

function TeamIllustration() {
  return (
    <svg
      viewBox="0 0 480 300"
      className="h-auto w-full rounded-xl border border-line bg-surface"
      role="img"
      aria-label="Illustration of a team collaborating over financial charts"
    >
      <rect x="0" y="0" width="480" height="300" fill="#F4F6FB" />
      <rect
        x="40"
        y="50"
        width="250"
        height="160"
        rx="10"
        fill="#ffffff"
        stroke="#E5E9F2"
      />
      <rect x="60" y="72" width="90" height="10" rx="5" fill="#E5E9F2" />
      <rect x="60" y="92" width="140" height="8" rx="4" fill="#EDF1F8" />
      <rect
        x="62"
        y="150"
        width="22"
        height="40"
        rx="3"
        fill="#2563EB"
        opacity="0.35"
      />
      <rect
        x="94"
        y="130"
        width="22"
        height="60"
        rx="3"
        fill="#2563EB"
        opacity="0.6"
      />
      <rect x="126" y="112" width="22" height="78" rx="3" fill="#2563EB" />
      <rect
        x="158"
        y="138"
        width="22"
        height="52"
        rx="3"
        fill="#2563EB"
        opacity="0.5"
      />
      <rect
        x="190"
        y="120"
        width="22"
        height="70"
        rx="3"
        fill="#2563EB"
        opacity="0.8"
      />
      <circle cx="360" cy="110" r="34" fill="#2563EB" opacity="0.15" />
      <circle cx="360" cy="98" r="14" fill="#2563EB" opacity="0.55" />
      <path
        d="M338 132 q22 -18 44 0 v14 h-44 z"
        fill="#2563EB"
        opacity="0.55"
      />
      <circle cx="415" cy="170" r="28" fill="#0B1437" opacity="0.12" />
      <circle cx="415" cy="160" r="11" fill="#0B1437" opacity="0.45" />
      <path
        d="M397 188 q18 -15 36 0 v10 h-36 z"
        fill="#0B1437"
        opacity="0.45"
      />
      <rect
        x="300"
        y="205"
        width="140"
        height="45"
        rx="8"
        fill="#ffffff"
        stroke="#E5E9F2"
      />
      <rect x="315" y="218" width="70" height="8" rx="4" fill="#E5E9F2" />
      <rect x="315" y="232" width="100" height="6" rx="3" fill="#EDF1F8" />
      <path
        d="M60 250 C110 235 150 255 200 240 C250 225 280 245 320 232"
        fill="none"
        stroke="#2563EB"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
}

export default function About() {
  return (
    <>
      <section className="section-container py-16 text-center">
        <h1 className="text-3xl font-bold sm:text-4xl">
          About Money Flow Accounting
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-slate-600">
          We're on a mission to make accounting simple, accessible, and
          affordable for every business.
        </p>
      </section>

      <section className="section-container pb-16">
        <TeamIllustration />
      </section>

      <section className="section-container pb-16">
        <div className="mx-auto max-w-3xl">
          <h2 className="text-2xl font-bold">Our Story</h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-600">
            Money Flow Accounting was founded by a team of accountants,
            developers, and business owners who understood the challenges of
            managing finances. We built Money Flow Accounting to help businesses
            save time, reduce errors, and make better financial decisions.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            It is built for the whole range of that work — from a freelancer
            sending a first invoice to a bookkeeper closing the books on several
            companies every month.
          </p>
        </div>
      </section>

      <section className="border-y border-line bg-surface py-16">
        <div className="section-container">
          <h2 className="text-center text-2xl font-bold">Our Values</h2>
          <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map(({ icon: Icon, title, copy }) => (
              <div key={title} className="card p-6 text-center">
                <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon size={20} />
                </span>
                <h3 className="mt-4 text-base font-semibold">{title}</h3>
                <p className="mt-2 text-sm text-slate-600">{copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner
        title="Ready to see it for yourself?"
        subtitle="Get started today."
        showSecondary={false}
        showChecks={false}
      />
    </>
  );
}
